import { render } from "./Feedback.vue?vue&type=template&id=e7d440b6&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=e7d440b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e7d440b6"

export default script